import React from 'react';
import { Link } from 'react-router-dom';
import PercentageValue from '../../../common/PercentageValue';
import CopyToClipboard from '../../../common/CopyToClipboard';

export const topTracksSettings = {
	settingsForTable
};


function settingsForTable(){
	let columns = [
		{
		   id: 'logo',
		   className: 'logo-sell',
		   headerClassName: 'logo-sell no-sort',
		   Header: '',
		   accessor: 'logo',
		   sortable: false,
		   width: 60,
		   Cell: props => {
			   return <div className="logo-container"><div id={`track_${props.original.track_id}`} className="milestone-anchor-container" /><div className="logo" style={{backgroundImage: `url(${props.value})`}} /></div>;
		   },
		   
	    },
		
		{
		   id: 'isrc',
		   className: '',
		   headerClassName: '',
		   Header: 'Track',
		   accessor: 'title',
		   Cell: props => {
			   return <span><span><b>{props.original.track_id ? <Link to={`/spotify-discovery/scorecard/${props.original.track_id}`}>{props.value}</Link> : props.value}</b></span>
			   <br/>
			   By: {props.original.artist}
			   <br/>
			   <span className="isrc-holder with-copy">
			   {props.original.track_id ? <CopyToClipboard value={props.original.isrc}>ISRC: {props.original.isrc}</CopyToClipboard> : <span>ISRC: {props.original.isrc}</span>}</span>
			   </span>
		   },

	   },
	   {
		   id: 'radio_units',
		   headerClassName: '',
		   Header: 'Radio Streams',
		   accessor: 'radio_units',
		   Cell: props => <PercentageValue field="radio_units" item={props.original}></PercentageValue>,
	   },
	   {
		  id: 'collection_units',
		  headerClassName: '',
		  Header: 'Collection Streams',
		  accessor: 'collection_units',
		  Cell: props => <PercentageValue field="collection_units" item={props.original}></PercentageValue>,
	  },

	];

	return columns;
}
